// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__kInf8","content":"GlobalSearch_content__1fZa-"};